<div class="wrapper__headerComponent container my-5">
  <div class="row align-items-center">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-6">
      <h2 class="text-center h3-tipografia-govco mb-0">
        {{ 'detalle-avance-procesal.lista-solicitudes' | translate }}
      </h2>
    </div>
  </div>
</div>
<div
  class="wrapper__contentComponent--expediente container my-5"
  id="encabezado">
  <app-encabezado-expediente></app-encabezado-expediente>
</div>
<div class="wrapper__contentComponent--expediente container my-5">
  <div class="contenedor-tabla w-100">
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      [datos]="avanceProcesalList"
      [paginaActual]="currentPage"
      [columnas]="columns"
      [paginacion]="true"
      [localFiltering]="true"
      [tamano]="pageSize"
      [totalPaginas]="totalPages"
      [tamanos]="[1, 5, 10, 20]"></app-table>
  </div>
</div>
